export default "__VITE_ASSET__DDz_N1or__"